
import React, { useState , useEffect , useRef } from 'react'
import '../../Assets/Css/ShareDistribution.scss'
import Table from '../../Components/Table';
import Select from "react-select";
import { customStyle } from '../../Components/Style';
import { connect } from 'react-redux';
import { getShareholdersList } from '../../Services/Shareholders/action';
import { addInternalTransaction , getAllInternalTrans , updateInternalTransaction } from '../../Services/Transactions/action';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { Spinner } from "react-bootstrap";
import qs from "query-string";



function ShareDistribution(props) {

  const navigate = useNavigate();
  const location = useLocation();
  let defaultData = location.state?.data;
  const [shareHolderOption , setShareHolderOption] = useState([]);
  const [selectedFromShareHolder , setSelectedFromShareHolder] = useState([]);
  const [selectedToShareHolder , setSelectedToShareHolder] = useState([]);
  const [formData,setFormData]=useState({
    description:"",
    amount:""
  })
  const [viewData,setViewData]=useState([]);
  const [isUpdate , setIsUpdate] = useState(false);
  const [oldAmount,setOldAmount]=useState(0);
  const [params, setParams] = useState({});
  const updateDivToFocus = useRef();
  let count = props.internalTransactions?.length;

  const setTheData = async()=>{
    try {
      await props.internalTransactions && setViewData(await props.internalTransactions.map(items=>{
        return{
          From : {
            value : items?.fromShareHolder?.name,
            type : 'text',
            fromId : items?.fromShareHolder?.id
          },
          To : {
            value : items?.toShareHolder?.name,
            type : 'text',
            toId : items?.toShareHolder?.id
          },
          description:{
            value : items?.description,
            type : 'description'
          },
          Amount : {
            value : `₹${items?.amount}`,
            type : "amount"
          },
          Date : {
            value : items?.created_at,
            type : "text"
          },
          Action: {
            value: '/transaction/ShareDistribution?limit=20&page=1',
            value2: '#',
            type: 'action'
          },
          transactionId: {
            value: items?.id,
          },
        }
      }))
    } catch (error) {
      console.error("Error Setting Transaction:", error);
      toast.error("Error : ",error);
    }
  }

  const fetchInternalTrans = async()=>{
    try {
      setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
      await props.getAllInternalTrans(location.search);
    } catch (error) {
      console.error("Error fetching Transaction:", error);
      toast.error("Error : ",error);
    }
  }

  useEffect(()=>{
    getShareHoldersForSelect();
    fetchInternalTrans();
  },[location.search])


  useEffect(()=>{
    if(defaultData?.transactionId?.value){
      if (updateDivToFocus.current) {
        updateDivToFocus.current.scrollIntoView({ behavior: 'smooth' });
      }  
      setIsUpdate(true);
      setFormData(preVal=>({
        ...preVal,
        description : defaultData?.description?.value || '',
        amount : defaultData?.Amount?.value?.slice(1) || '',
      }))
      const fromSh = shareHolderOption.find((item)=>item.value===defaultData?.From?.fromId);
      const toSh = shareHolderOption.find((item)=>item.value===defaultData?.To?.toId);
      setSelectedFromShareHolder(fromSh);
      setSelectedToShareHolder(toSh);
      setOldAmount(defaultData?.Amount?.value?.slice(1));
    }
  },[defaultData])

  useEffect(()=>{
    setTheData();
  },[props.internalTransactions])
  
  const getShareHoldersForSelect= async()=>{
    try {
      await props.getShareholdersList();
    } catch (error) {
      console.log("Error while Getting ShareHodlers List");
    }
  }

  useEffect(()=>{
    setShareHolderOption(props.shareholdersList?.map(items=>{
      return {
        value : items.id,
        label : items.name
      }
    }))
  },[props.shareholdersList]);
 

  const header = [
    { field: 'From' },
    { field: 'To' },
    { field: 'description' },
    { field: 'Amount' },
    { field: 'Date' },
    { field: 'Action' }
  ]
  let footer = true
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((preVal) => ({
      ...preVal,
      [name]: value,
    }));
  };

  const checkEmpty = ()=>{
    if(selectedFromShareHolder.length <= 0 || selectedToShareHolder.length <=0 || formData.amount=="" || formData.description==""){
      toast.error("Please Fill All Fields");
      return true;
    }
    if(formData.amount < 0){
      toast.error("Minimum Amount should be 0");
      return true;
    }
    return false;
  }

  const handleSubmit = async(e)=>{
    if(checkEmpty()) return;
    let operation,diff;
    let oldAmountVal=parseFloat(oldAmount);
    let newAmount=parseFloat(formData.amount);
    e.preventDefault();
    if(isUpdate){
      if(newAmount > oldAmountVal){
        operation = "minus";
        diff = newAmount - oldAmountVal;
      }else{
        operation = "add";
        diff = oldAmountVal - newAmount;
      }
    }
    try {
      const postData = {
        ...formData,
        from : selectedFromShareHolder.value,
        to: selectedToShareHolder.value,
      }
      const updateData = {
        ...postData,
        operation,
        diff
      }
      isUpdate===true ? await props.updateInternalTransaction(updateData,defaultData?.transactionId?.value) : await props.addInternalTransaction(postData);
      setFormData({
        description:"",
        amount: ""
      })
      setSelectedFromShareHolder([]);
      setSelectedToShareHolder([]);
      setShareHolderOption(props.shareholdersList?.map(items=>{
        return {
          value : items.id,
          label : items.name
        }
      }))
      fetchInternalTrans();
      setIsUpdate(false);
      defaultData=undefined;
    } catch (error) {
      console.log("Error While Adding Transaction :", error);
    }
  }

  const onFromChange = (val)=>{
    setSelectedFromShareHolder(val);
    setShareHolderOption(shareHolderOption.filter(item=>item.value!==val.value))
  }
  const onToChange = (val)=>{
    setSelectedToShareHolder(val);
    setShareHolderOption(shareHolderOption.filter(item=>item.value!==val.value))
  }
  return (
      <div className='ShareDistribution-main' ref={updateDivToFocus}>
        <div className='page-title'>
          <h4>Share Distribution</h4>
        </div>
        <div className='content-part'>
          <div className='user-information'>
            <div className='row user-card'>
              <div className='col-lg-6 col-md-12'>
                <div className="card-type">
                  <label className="labeling">
                    <div className="label-gap">From</div>
                    <Select
                      defaultValue={selectedFromShareHolder}
                      onChange={onFromChange}
                      value={selectedFromShareHolder}
                      options={shareHolderOption}
                      isDisabled={props.loading}
                      styles={customStyle}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#5757fe",
                          primary: "#5757fe",
                        },
                      })}
                    />
                  </label>
                </div>
              </div>
              <div className='col-lg-6 col-md-12'>
              <div className="card-type">
                  <label className="labeling">
                    <div className="label-gap">To</div>
                    <Select
                      defaultValue={selectedToShareHolder}
                      onChange={onToChange}
                      value={selectedToShareHolder}
                      options={shareHolderOption}
                      isDisabled={props.loading}
                      styles={customStyle}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#5757fe",
                          primary: "#5757fe",
                        },
                      })}
                    />
                  </label>
                </div>
              </div>
            </div>
            <div className='row '>
              <div className='col-lg-12'>
                <div className="card-type">
                  <label className="labeling">
                    <div className="label-gap">Description</div>
                    <textarea className='input-css' name='description' disabled={props.loading} rows='4' cols='25' value={formData.description} onChange={handleChange}/>
                  </label>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-lg-6 col-md-12'>
                <div className="card-type">
                  <label className="labeling">
                    <div className="label-gap">Amount</div>
                    <div>
                      <input className="input-css" disabled={props.loading} type='number' placeholder='Enter Amount' name='amount' value={formData.amount} onChange={handleChange}/>
                    </div>
                  </label>
                </div>
              </div>
              <div className='col-lg-6 col-md-12'>
                <div className="card-type">
                <div className="apply-btn">
                  <div className="edit-btn">
                    <button className="custom-btn" disabled={props.loading} onClick={handleSubmit}>
                        {props.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : "Submit"}
                      </button>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
          <div className="table-part">
            <Table header={header} data={viewData} footer={footer} showIsView={false} loading={props.loading} count={count} records = {parseFloat(props.records)} defaultParams={params}/>
          </div>
        </div>
      </div>

  )
}

const mapStateToProps = (state)=>{
  return {
    shareholdersList : state.shareholdersReducer.shareholderslist,
    loading : state.transactionReducers.loading,
    internalTransactions : state.transactionReducers.internalTransactions.rows,
    records : state.transactionReducers.internalTransactions.noOfRecords
  }
}

const mapDispatchToProps = (dispatch)=>{
  return {
    getShareholdersList : ()=>{
      dispatch(getShareholdersList());
    },
    addInternalTransaction : (postData)=>{
      dispatch(addInternalTransaction(postData));
    },
    getAllInternalTrans : (params)=>{
      dispatch(getAllInternalTrans(params));
    },
    updateInternalTransaction : (data,id)=>{
      dispatch(updateInternalTransaction(data,id))
    }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(ShareDistribution);